import { useConfig } from "@/config.ts";

/* eslint-disable react-refresh/only-export-components */

function SiteName() {
    const { siteName } = useConfig();
    return siteName;
}

// Using a constant `{siteName}` instead of `<SiteName />` in JSX improves the translation `.po` file by including the
// constant's name in the `msgstr`.
export const siteName = <SiteName />;
